module.exports = __webpack_public_path__ + "img/g.90c7db03.jpg";